/**
 * Badge Component
 *
 * Reusable decorative badge component using the badge.svg asset.
 * Used often in the Hero section and section headers.
 *
 * Props:
 * @param containerStyles - Tailwind classes to override/add to the container
 */
import { Image } from "@heroui/image";

const Badge = ({ containerStyles }: { containerStyles?: string }) => {
  return (
    <div className={`relative ${containerStyles}`}>
      <Image
        alt=""
        className="object-contain"
        height={280}
        src="/assets/badge.svg"
        width={280}
      />
    </div>
  );
};

export default Badge;
